module.exports = __webpack_public_path__ + "static/media/KioskUserInformationScreen.1abb756d.png";